import Vuetify from 'vuetify/lib'
import config from "../config";
import '@mdi/font/css/materialdesignicons.css'


export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            dark: config.dark,
            light: config.light,
        }
    },
    icons: {
        iconfont: 'mdi'
    }
});
